<template>
  <v-card class="main-content-card">
    <v-toolbar flat>
      <v-toolbar-title>知识产权查看</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn round small color="orange darken-1" class="white--text"
             target="_blank"
             :href="excelUrl">
        <v-icon dark small>table_chart</v-icon>导出Excel
      </v-btn>
    </v-toolbar>
    <v-divider/>
    <!-- 检索功能区 -->
    <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
      <v-layout row wrap>
        <v-flex d-flex xs10>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-text-field
                label="知识产权名称"
                v-model="form.name"
                :clearable="true"
                hide-details
              />
            </v-flex>

            <v-flex xs12 sm3>
              <v-autocomplete
                item-text="name"
                item-value="dbid"
                :items="typeItems"
                v-model="form.typeId"
                label="知识产权类型"
                hide-details
                clearable
                :menu-props="{maxHeight:600}"
              />
            </v-flex>
            <v-flex xs12 sm3>
              <v-text-field
                label="申请号/登记号"
                v-model="form.number"
                :clearable="true"
                hide-details
              />
            </v-flex>
            <v-flex xs12 sm4>
              <v-menu
                      ref="refApplDateStart"
                      :close-on-content-click="false"
                      v-model="menuApplDateStart"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
              >
                <v-text-field
                        slot="activator"
                        v-model="form.applDateStart"
                        label="申请日期(起始)"
                        clearable
                        :rules="rules.applDateStart"
                        hint="格式YYYY-MM-DD, 如：2018-10-01"
                        persistent-hint
                />
                <v-date-picker
                        v-model="applDateStart"
                        locale="zh-cn"
                        @change="nv => form.applDateStart= nv"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4>
              <v-menu
                      ref="refApplDateEnd"
                      :close-on-content-click="false"
                      v-model="menuApplDateEnd"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
              >
                <v-text-field
                        slot="activator"
                        v-model="form.applDateEnd"
                        label="申请日期(截止)"
                        clearable
                        :rules="rules.applDateEnd"
                        hint="格式YYYY-MM-DD, 如：2018-10-01"
                        persistent-hint
                />
                <v-date-picker
                        v-model="applDateEnd"
                        locale="zh-cn"
                        @change="nv => form.applDateEnd= nv"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4>
              <v-autocomplete
                item-text="name"
                item-value="dbid"
                :items="outcomeStateItems"
                v-model="form.outcomeStateId"
                label="成果状态"
                hide-details
                clearable
                :menu-props="{maxHeight:600}"
              />
            </v-flex>
            <v-flex xs12 sm4>
              <v-menu
                      ref="refAuthoredDateStart"
                      :close-on-content-click="false"
                      v-model="menuAuthoredDateStart"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
              >
                <v-text-field
                        slot="activator"
                        v-model="form.authoredDateStart"
                        label="授权日期(起始)"
                        clearable
                        :rules="rules.authoredDateStart"
                        hint="格式YYYY-MM-DD, 如：2018-10-01"
                        persistent-hint
                />
                <v-date-picker
                        v-model="authoredDateStart"
                        locale="zh-cn"
                        @change="nv => form.authoredDateStart= nv"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4>
              <v-menu
                      ref="refAuthoredDateEnd"
                      :close-on-content-click="false"
                      v-model="menuAuthoredDateEnd"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
              >
                <v-text-field
                        slot="activator"
                        v-model="form.authoredDateEnd"
                        label="授权日期(截止)"
                        clearable
                        :rules="rules.authoredDateEnd"
                        hint="格式YYYY-MM-DD, 如：2018-10-01"
                        persistent-hint
                />
                <v-date-picker
                        v-model="authoredDateEnd"
                        locale="zh-cn"
                        @change="nv => form.authoredDateEnd= nv"
                />
              </v-menu>
            </v-flex>

        <!--    <v-flex xs12 sm4>
              <v-text-field
                      label="参与人"
                      v-model="form.app"
                      :clearable="true"
                      hide-details
              />
            </v-flex>-->
          </v-layout>
        </v-flex>
        <v-flex d-flex xs2 text-xs-center>
          <div>
            <v-btn color="primary" @click="onSearch">
              <v-icon dark>search</v-icon>
              检索
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider/>
    <v-data-table
      :headers="headers"
      :loading="loading"
      item-key="dbid"
      :pagination.sync="query"
      :items="pageResult.items"
      :total-items="pageResult.total"
      rows-per-page-text="每页记录数"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{props.item.name }}<br>{{props.item.type.name }}<br>{{props.item.number}}</td>
        <td> {{ (props.item.persons || []).map( v => `${v.name}(${v.order})` ).join(', ') }}<br>{{props.item.department.name}}</td>
        <td>{{props.item.appDate}}<br>{{props.item.authoredDate}}</td>
        <td>{{props.item.submitDate}}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { $router.push(`/inte/view/${props.item.dbid}`) }">
              <v-icon color="teal">toc</v-icon>
            </v-btn>
            <span>管理/查看</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'
 // import XView from './registView'
  import mixin from '@/mixin'
  const  baseUri= '/api/inte/intellectualManage/by/request/user'
  const statusUri = '/api/code/status';
  const inteTypeUri = '/api/inte/intellectualType';
  const deptUri = '/api/syst/department';
  const outcomeStateUri = '/api/inte/outcomeState/';
  export default {
    // 混入模块列表页面（index）基本功能
    mixins: [mixin.index(baseUri)],
    //components: {XView},
    data() {
      return {
        uri: baseUri,
        fileUri: '/api/inte/file',
        searchName: '',
        loading: false,
        total: 0,
        items: [],

        // 检索、分页、排序条件条件
        query: {
          statusId: '',
          name: '',
          typeId: '',
          number: '',
        //  app: '',
          outcomeStateId: '',
          applDateStart: '',
          applDateEnd: '',
          authoredDateStart: '',
          authoredDateEnd: '',
          departmentId: '',

          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          descending: null,
          totalItems: null
        },
        // 检索框
        form: {
          statusId: '',
          name: '',
          typeId: '',
          number: '',
         // app: '',
          outcomeStateId: '',
          applDateStart: '',
          applDateEnd: '',
          authoredDateStart: '',
          authoredDateEnd: '',
          departmentId: '',
        },

        statusItems: [],
        typeItems: [],
        outcomeStateItems: [],

        menuApplDateStart: false,
        menuApplDateEnd: false,
        menuAuthoredDateStart: false,
        menuAuthoredDateEnd: false,

        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '知识产权名称/类型/(申请号/登记号)', align: 'left', sortable: true, value: 'name'},
          {text: '参与人/知识产权所属部门', align: 'left', sortable: true, value: 'persons'},
          {text: '申请日期/授权日期', align: 'left', sortable: true, value: 'appDate'},
         // {text: '授权日期', align: 'left', sortable: true, value: 'authoredDate'},
          {text: '成果登记日期', align: 'left', sortable: true, value: 'submitDate'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid'}
        ],

        rowIdx: null,

        dele: false,
        deleDbid: null,
        deleMsg: null,

        edit: false,
        editDbid: null,

        hist: false,
        history: [],

          rules: {
              applDateStart: [
                  v => !!v || "必填项。",
                  v => window.xutil.regexpDate().test(v) || '日期格式错误'
              ],
              applDateEnd: [
                  v => !!v || "必填项。",
                  v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
                  v => (v && v >= this.form.applDateStart) || "截止日期必须晚于或等于起始日期。"
              ],
              authoredDateStart: [
                  v => !!v || "必填项。",
                  v => window.xutil.regexpDate().test(v) || '日期格式错误'
              ],
              authoredDateEnd: [
                  v => !!v || "必填项。",
                  v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
                  v => (v && v >= this.form.authoredDateStart) || "截止日期必须晚于或等于起始日期。"
              ]
          }
      }

    },

    created() {
      // 加载审核状态
      this.axios.all([
        this.axios.get(statusUri, {params: {sort: 'rank.asc'}}),
        this.axios.get(inteTypeUri, {params: {sort: 'order.asc'}}),
        this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
        this.axios.get(outcomeStateUri, {params: {sort: 'order.asc'}}),
      ]).then(
        this.axios.spread(
          (rspStaus,rspType, rspDept, rspOutcomeState) => {
            this.statusItems = rspStaus.data.items;
            this.typeItems =rspType.data.items;
            this.deptItems = rspDept.data.items;
            this.outcomeStateItems = rspOutcomeState.data.items;
          }
        )
      )
    },

    watch: {
    },

    computed: {
      ...mapGetters(['funcIds']),
        excelUrl() {
            // window.console.log(this.form);
            const url = '/api/inte/excel/exp/userexcel';
            return window.xutil.buildUrl(url, Object.assign({limit: -1}, this.form))
        },
    },

    methods: {
      remote(item, queryText, itemText) {
        // 用于远下拉框的过滤，所以所有选都是显示在下拉框中
        return true;
      },

      /**
       * **************************************************************
       * 事件响应函数
       */
      // 检索响应函数
      onSearch() {
        Object.assign(this.query, this.form);
        this.query.page = 1;
        this.doRoute(this.query);
      }
    }
  }
</script>
